import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';

@Component({
    selector: 'app-health-analysis',
    templateUrl: './health-analysis.component.html',
    standalone: false
})
export class HealthAnalysisComponent implements OnInit{
  set_html: any;

  constructor(
    public dialogConfig: DialogConfig,
    private sanitizer: DomSanitizer
  ){}
  
  ngOnInit(){
    console.log("Dialog Config", this.dialogConfig);
    if(this.dialogConfig?.data?.message){
      this.set_html = this.sanitizer.bypassSecurityTrustHtml(this.dialogConfig.data.message);
    }
  }

}
